<template>
    <div
        at-m-input-wrapper
        class="m-input-wrapper input-wrapper"
    >
        <ValidationProvider
            :rules="validationRules"
            :mode="validationMode"
            v-slot="{ errors }"
            tag="div"
        >
            <div
                class="input-control"
                :class="{ 'input-control--error': errors[0] }"
            >
                <label
                    class="input-label-wrapper"
                    :class="[`input-label-wrapper--${slotType}`, { 'input-label-wrapper--error': errors[0] }]"
                >
                    <slot />
                    <div class="input-label">
                        <span class="input-label-text">{{ labelText }}</span>
                        <span
                            v-if="errors[0]"
                            class="input-label-error"
                        >
                            {{ locale(errors[0]) }}
                        </span>
                    </div>
                </label>
            </div>
        </ValidationProvider>
        <AButtonCopy
            v-if="copyInputId"
            :copy-input-id="copyInputId"
            :text-title="locale('copy_text_title')"
            :text-confirm="locale('copy_text_confirm')"
            class="input-copy-button"
        />
    </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

import AButtonCopy from '../../atoms/a-button-copy';

import { locale } from './../../../utils/services/localization-service';

export default {
    name: 'MInputWrapper',
    components: {
        AButtonCopy,
        ValidationProvider
    },
    props: {
        /**
         * Label text for input
         */
        labelText: {
            type: String,
            default: ''
        },
        /**
         * Detect type of slot element to apply another style
         */
        slotType: {
            type: String,
            default: 'input'
        },
        /**
         * Validation rules
         */
        validationRules: {
            type: [String, Object],
            default: () => ''
        },
        /**
         * Set Validation mode
         */
        validationMode: {
            type: String,
            default: 'validateOnBlur'
        },
        /**
         * Set ID of target input to copy and show the clipboard button
         */
        copyInputId: {
            type: String,
            default: ''
        }
    },
    methods: {
        locale(key) {
            return locale(key);
        }
    }
};
</script>

<style lang="scss">
    @import 'theme';
</style>
